<template>
    <div>
        <!-- Modal dialog content -->
        <component :is="modalMode ? 'modal' : 'div'" :id="modalId" :title="title">

            <div class="row m-b-md m-t-md">
                <div class="col-md-12">
                    <div class="profile-image">
                        <img :src="photoLink" class="img-circle circle-border" alt="profile">
                    </div>
                    <div class="profile-info">
                        <div>
                            <h2 class="no-margins">
                                {{ contact.name }}
                            </h2>
                            <span class="no-margins">{{ contact.type_title }}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div class="row m-b-sm">

                <div class="col-md-6">
                    <div class="ibox-content">
                        <dl class="row m-b-none">
                            <dt class="col-md-6">Full Name:</dt>
                            <dd class="col-md-6 pl-0">{{ contact.full_name }}</dd>
                            <dt class="col-md-6">First name:</dt>
                            <dd class="col-md-6 pl-0">{{ contact.first_name }}</dd>
                            <dt class="col-md-6">Last name:</dt>
                            <dd class="col-md-6 pl-0">{{ contact.last_name }}</dd>
                            <dt class="col-md-6">Business Name:</dt>
                            <dd class="col-md-6 pl-0">{{ contact.business_name }}</dd>
                            <dt class="col-md-6">Commercial Contact:</dt>
                            <dd class="col-md-6 pl-0">{{ contact.commercial_contact }}</dd>
                            <dt class="col-md-6">Tax ID:</dt>
                            <dd class="col-md-6 pl-0">{{ contact.tax_id }}</dd>
                        </dl>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="ibox-content">
                        <dl class="row m-b-none">
                            <dt class="col-md-6">Address:</dt>
                            <dd class="col-md-6 pl-0">{{ contact.address }}</dd>
                            <dt class="col-md-6">City:</dt>
                            <dd class="col-md-6 pl-0">{{ contact.city }}</dd>
                            <dt class="col-md-6">State:</dt>
                            <dd class="col-md-6 pl-0">{{ contact.state ? contact.state_title : '' }}</dd>
                            <dt class="col-md-6">Zip:</dt>
                            <dd class="col-md-6 pl-0">{{ contact.zip }}</dd>
                        </dl>
                    </div>
                </div>

            </div>

            <div class="row">

                <div class="col-md-6">
                    <div class="ibox-content">
                        <dl class="row m-b-none">

                            <template v-for="(item, index) in contact.phones">
                                <dt class="col-md-6"><span v-if="item.is_primary"><i class="fa fa-flag"></i> Primary </span>{{ phoneTitle(item.type) }}:</dt>
                                <dd class="col-md-6 pl-0">
                                    {{ item.phone }}
                                    <div v-if="item.notes" class="text-muted"><small>{{ item.notes }}</small></div>
                                </dd>
                            </template>

                            <template v-for="(item, index) in contact.emails">
                                <dt class="col-md-6"><span v-if="item.is_primary"><i class="fa fa-flag"></i> Primary </span>Email:</dt>
                                <dd class="col-md-6 pl-0">
                                    {{ item.email }}
                                    <div v-if="item.notes" class="text-muted"><small>{{ item.notes }}</small></div>
                                </dd>
                            </template>

                            <template v-for="(item, index) in contact.links">
                                <dt class="col-md-6"><span v-if="item.is_primary"><i class="fa fa-flag"></i> Primary </span>Link:</dt>
                                <dd class="col-md-6 pl-0">
                                    <a :href="item.link">{{ parseDomain(item.link) }}</a>
                                    <div v-if="item.notes" class="text-muted"><small>{{ item.notes }}</small></div>
                                </dd>
                            </template>

                        </dl>
                    </div>
                </div>

                <div class="col-md-6">
                    <div class="ibox-content">
                        <dl class="row m-b-none">
                            <dt class="col-md-6">Contact Method:</dt>
                            <dd class="col-md-6 pl-0">{{ contact.contact_method ? contact.contact_method_title : '' }}</dd>
                            <dt class="col-md-6">Contact Notes:</dt>
                            <dd class="col-md-6 pl-0">{{ contact.notes }}</dd>
                        </dl>
                    </div>
                </div>

            </div>

            <div class="row m-t-md m-b-n" v-if="showW9 && contact.w9_on_file">

              <div class="col-md-12">
                <div class="alert text-center font-bold alert-info m-b-xxs">W9 on file</div>
              </div>

            </div>

            <template #footer>
                <button type="button" class="btn btn-default" @click="$modal.hide(modalId)">Close</button>
            </template>

        </component>

    </div>
</template>

<script>

  export default {

    /**
     * Input properties
     */
    props: {
      // Values for edit
      modelValue: {
        type: Object,
        default: () => {
        }
      },

      modalMode: {
        type: Boolean,
        default: true
      },

      // Modal dialog id
      modalId: {
        type: String,
        default: "contactViewModal"
      },

      // Modal dialog title
      title: {
        type: String,
        default: "Contact information"
      },

      // Show "W9 on file" marker.
      showW9: {
        type: Boolean,
        default: false
      }

    },

    /**
     * Variables (models)
     */
    data() {
      return {
        // Current contact object
        contact: {},

        // Phone types list
        phoneTypes: ['cell', 'home', 'work', 'other']
      }
    },

    /**
     * Computed values
     */
    computed: {

      /**
       * Link to contact image
       */
      photoLink() {
        return this.contact.photo ? '/storage/' + this.contact.photo : '/images/profile_small.png';
      },
    },

    /**
     * Functions (methods)
     */
    methods: {

      /**
       * Phone title
       */
      phoneTitle(type) {
        return 'Phone' + (type === 'other' ? '' : ' (' + type.charAt(0).toUpperCase() + type.slice(1) + ')');
      },

      /**
       * Domain from url
       */
      parseDomain(url) {
        let domain;
        // remove protocol
        if (url.indexOf("//") > -1) {
          domain = url.split('/')[2];
        } else {
          domain = url.split('/')[0];
        }
        // remove port number
        domain = domain.split(':')[0];
        // remove "?"
        domain = domain.split('?')[0];
        // check if domain is valid
        let psl = require('psl');
        domain = psl.get(domain);
        // if no data parsed return url
        if (!domain) domain = url;
        return domain;
      }

    },

    /**
     * Watchers
     */
    watch: {
      modelValue: {
        handler: function (val) {
          // Clone value prop to contact object to avoid prop direct modification
          this.contact = _.cloneDeep(val);
        },
        immediate: true
      },
    }

  }
</script>

<style scoped>

</style>
